import Component from '../colorz/Component';

import device from '../colorz/utils/device';

module.exports = class Menu extends Component {
  onInit( el, args) {
    this.onScroll = this.onScroll.bind( this );

    // Initializations
    this.el     = el; 
    this.elHeight = this.el.offsetHeight;
    this.items  = this.el.querySelectorAll('.menu-item a');
    this.subItems  = this.el.querySelectorAll('.menu-item .sub-menu a');
    this.timeout = null;
  }

  onReady() {
    if ( device.width > 1080 ) {
      document.body.style.paddingTop = this.elHeight+'px';
    }


    for (var i = 0; i < this.items.length; i++) {
      var href = this.items[i].href;
      var baseUrl = window.location.href;

      if (href == baseUrl) {
        this.items[i].parentNode.classList.add('is-active');
      }
    }

    for (var i = 0; i < this.subItems.length; i++) {
      var href = this.subItems[i].href;
      var baseUrl = window.location.href;

      if (href == baseUrl) {
        // comment accéder à l'arrière grand parent sans faire cette magnifique queueu-leu-leu de node ?
        this.subItems[i].parentNode.parentNode.parentNode.classList.add('is-active');
      }
    }
  }

  onScroll() {
    if ( device.scroll.top > this.elHeight ) {
      this.el.classList.add('is-fixed');
    } else {
      this.el.classList.remove('is-fixed');
    }
  }
}